import VueGapi from "vue-gapi";

export default {
  install: function(app /*, options*/) {
    app.use(VueGapi, {
      apiKey: "AIzaSyBAiGAXOm1h3M_pyqCN0iWWqfjemJk37F4",
      // clientId: "<YOUR_CLIENT_ID>.apps.googleusercontent.com",
      discoveryDocs: [
        "https://www.googleapis.com/discovery/v1/apis/youtube/v3/rest"
      ]
      //   scope: "https://www.googleapis.com/auth/youtube.readonly"
    });
  }
};
